<template>
  <div class="formAreaCheckbox">
    <div
      class="formAreaCheckbox_ttl"
      :class="{
        '-expanded': state.isExpand,
        '-border': titleHasBorder
      }"
      @click="handleToggle($event)"
    >
      <p class="formAreaCheckbox_label">{{ label }}</p>
      <span
        v-if="enableAllCheck"
        class="formAreaCheckbox_status"
        :class="{ '-selected': status !== '未選択' }"
      >
        {{ status }}
      </span>
    </div>

    <div class="formAreaCheckbox_body">
      <ul class="checkboxButtons" :class="{ '-variable': variableSize }">
        <li v-if="enableAllCheck">
          <CheckboxButton
            label="全て選択する"
            value=""
            :id="id"
            :checked="status === '全て選択'"
            @call-input-change="checkAll"
            narrow
          />
        </li>
        <li v-for="(item, i) in items" :key="i">
          <CheckboxButton
            :label="item.label"
            :id="item.id"
            :value="item.value"
            :error="item.error"
            :checked="item.checked"
            @call-input-change="checkSingle"
            narrow
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, computed, SetupContext } from 'vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'

export default {
  name: 'FormAreaCheckbox',

  components: {
    CheckboxButton
  },

  props: {
    label: String,
    items: Array,
    id: {
      type: String,
      required: true
    },
    enableAllCheck: {
      type: Boolean,
      default: true
    },
    titleHasBorder: {
      type: Boolean,
      default: false
    },
    variableSize: {
      type: Boolean,
      default: false
    },
    gatAllOnce: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any, context: SetupContext) {
    const state = reactive({
      isExpand: false
    })

    const handleToggle = (ev: any) => {
      state.isExpand = state.isExpand ? false : true

      const next = ev.target.nextElementSibling
      const height = next.firstElementChild.clientHeight + 20

      next.style.height = state.isExpand ? height + 'px' : '0'
    }

    const status = computed(() => {
      const selectedItems = props.items.filter((item: any) => {
        return item.checked
      })

      if (selectedItems.length === props.items.length) return '全て選択'
      if (selectedItems.length > 0) return '選択中'
      return '未選択'
    })

    const checkAll = (ev: any) => {
      const selectedItems = props.items.filter((item: any) => {
        return item.checked
      })

      // 全て選択されていたら全て解除
      // それ以外は全て選択
      if (props.gatAllOnce) {
        // 一度でtrue/falseを送る
        context.emit(
          'select-area',
          selectedItems.length === props.items.length ? false : true
        )
      } else {
        // 都道府県の分だけemit実行
        props.items.forEach((item: any) => {
          context.emit('check-prefecture', {
            value: item.value,
            checked: selectedItems.length === props.items.length ? false : true
          })
        })
      }
    }

    const checkSingle = (ev: any) => {
      context.emit('check-prefecture', ev)
    }

    return {
      state,
      status,
      handleToggle,
      checkAll,
      checkSingle
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.formAreaCheckbox {
  margin-top: 30px;

  @include mixins.media() {
    margin-top: 40px;
  }

  & + & {
    margin-top: 20px;
  }

  &_body {
    height: 0;
    overflow: hidden;
    transition: all 0.5s;

    > .checkboxButtons {
      margin-top: 16px;
    }
  }

  &_ttl {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e4e4e4;
    padding-bottom: 12px;
    align-items: center;

    &::after {
      margin-left: 16px;
      display: block;
      content: '';
      width: 20px;
      height: 20px;
      background-image: url('~@/assets/icon/expand_off.svg');
      background-size: 20px 20px;
    }

    &.-expanded::after {
      background-image: url('~@/assets/icon/expand_on.svg');
    }

    &.-border {
      padding-left: 13px;
      font-size: 1.8rem;
      line-height: 1.7;
      position: relative;
      &::before {
        content: '';
        display: block;
        width: 4px;
        height: calc(100% - 12px);
        position: absolute;
        top: 0;
        left: 0;
        background-color: var.$color-main;
      }
    }
  }

  &_label {
    font-size: 1.4rem;
    font-weight: 500;
    margin-right: auto;
    pointer-events: none;
  }

  &_status {
    font-size: 1rem;
    width: 50px;
    border: 1px solid #c6c6c6;
    text-align: center;
    color: #c6c6c6;
    pointer-events: none;

    &.-selected {
      border-color: var.$color-main;
      color: var.$color-main;
    }
  }
}

.checkboxButtons {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -7px 20px;

  & > li {
    margin: 7px;
    flex-basis: calc(50% - 14px);

    @include mixins.media() {
      flex-basis: calc(25% - 14px);
    }
  }

  &.-variable {
    margin: 17px -4px 28px;
    > li {
      margin: 8px 4px;
      flex-basis: unset;
    }
  }
}
</style>
